// System
export const ADMIN_ROUTE = '/administration'
export const USER_ACC_ROUTE = '/account'
export const USER_DASHBOARD_ROUTE = '/dashboard'
export const LOGIN_ROUTE = '/login'
export const REGISTRATION_ROUTE = '/registration'
export const PRICING_ROUTE = '/pricing'
export const POLL_LIBRARY_ROUTE = '/survey_library'
export const LIBRARY_ROUTE = '/library'
export const PAY_ROUTE = '/pay';
export const RETURN_ROUTE = '/return';
export const RETURN_ROUTE_ADD_FUNDS = '/return-add-funds';
export const RESET_PASSWORD_ROUTE = '/reset_password';
export const SET_NEW_PASSWORD_ROUTE = '/set_new_password';
export const TERMS_OF_USE_ROUTE = '/terms_of_use';
export const PRIVACY_POLICY_ROUTE = '/privacy_policy';
export const ADD_FUNDS_TO_USD_BALANCE_ROUTE = '/add-funds';
export const NEWS_ROUTE = '/news';
export const NEWS_DETAIL_ROUTE = '/news/:slug';
export const LANG_PREFIX_ROUTE = "/:lang";
export const PROMO_PAY_ROUTE = '/promotion';
export const VERIFY_EMAIL_ROUTE = '/verify-email';
export const STORE_ROUTE = '/amazon-product-store';
export const EMAIL_UNSUBSCRIBE_ROUTE = '/email-unsubscribe';
// SEO Public
export const MAIN_ROUTE = '/'
export const ABOUT_ROUTE = '/about';
export const HOW_IT_WORKS_ROUTE = '/how-it-works';
export const FAQ_ROUTE = '/faq';
export const BLOG_ROUTE = '/blog';  // 301
export const CONTACT_ROUTE = '/contact';
export const AFFILIATE_ROUTE = '/affiliate-program'

// KDP Tools Hub
export const KDP_TOOLS_ROUTE = "/kdp-tools";
export const AMAZON_BSR_CALCULATOR_ROUTE = "/amazon-bsr-calculator";
export const AMAZON_BSR_CALCULATOR_HOW_TO_USE_ROUTE = "/amazon-bsr-calculator-how-to-use";
export const AMAZON_BSR_PSYCHOLOGY_AND_MOTIVATION_ROUTE = "/amazon-bsr-psychology-and-motivation";

// AI KDP Book Creator (hub)
export const AI_TOOLS_FOR_KDP_ROUTE = "/ai-tools-for-kdp";

// AI KDP Book Creator – sub tools
export const AI_BOOK_TITLE_GENERATOR_ROUTE = "/ai-book-title-generator";
export const AI_BOOK_DESCRIPTION_GENERATOR_ROUTE = "/ai-book-description-generator";
export const AI_BOOK_CATEGORY_FINDER_ROUTE = "/ai-book-category-finder";

// Free tools for authors (hub)
export const FREE_TOOLS_FOR_AUTHORS_ROUTE = "/free-tools-for-authors";
// Free tools
export const QR_CODE_GENERATOR_FOR_BOOKS_ROUTE = "/qr-code-generator-for-books";
export const PUZZLE_GENERATOR_FOR_KDP_ROUTE = "/puzzle-generator-for-kdp";

export const AMAZON_SUGGESTIONS_ROUTE = '/amazon-suggestions-extractor';

// HUB
export const GET_AMAZON_BOOK_REVIEWS_ROUTE = '/get-amazon-book-reviews';
// TREE
export const FREE_AMAZON_BOOK_REVIEWS_ROUTE = '/free-amazon-book-reviews';
export const VERIFIED_PURCHASE_AMAZON_BOOK_REVIEWS_ROUTE = '/verified-purchase-amazon-book-reviews';
export const ARE_AMAZON_BOOK_REVIEWS_HARD_TO_GET_ROUTE = '/are-amazon-book-reviews-hard-to-get';
export const ARC_BOOK_REVIEWS_AMAZON_ROUTE = '/arc-book-reviews-amazon';
export const AMAZON_BOOK_REVIEW_EXCHANGE_ROUTE = '/amazon-book-review-exchange';
export const AMAZON_REVIEW_EXCHANGE_POLICY_ROUTE = '/amazon-review-exchange-policy';
export const AMAZON_REVIEW_RULES_ROUTE = '/amazon-review-rules';
export const HOW_TO_GET_AMAZON_REVIEWS_LEGALLY_ROUTE = '/how-to-get-amazon-reviews-legally';
export const AMAZON_REVIEW_TIMELINE_ROUTE = '/amazon-review-timeline';
export const WHY_AMAZON_REVIEWS_DISAPPEAR_ROUTE = '/why-amazon-reviews-disappear';
export const BOOK_REVIEW_SITES_FOR_AUTHORS_ROUTE = '/book-review-sites-for-authors';
export const PAID_BOOK_REVIEW_SERVICES_ALTERNATIVES_ROUTE = '/paid-book-review-services-alternatives';
export const ARE_PAID_AMAZON_REVIEWS_SAFE_ROUTE = '/are-paid-amazon-reviews-safe';
export const SAFE_ALTERNATIVE_TO_PAID_BOOK_REVIEWS_ROUTE = '/safe-alternative-to-paid-book-reviews';

// HUB
export const KDP_EARNINGS_ROUTE = '/kdp-earnings';
// TREE
export const HOW_MUCH_DO_AUTHORS_MAKE_ON_AMAZON_ROUTE = '/how-much-do-authors-make-on-amazon';
export const HOW_MUCH_MONEY_CAN_YOU_MAKE_ON_KDP_ROUTE = '/how-much-money-can-you-make-on-kdp';
export const AMAZON_SELF_PUBLISHING_INCOME_ROUTE = '/amazon-self-publishing-income';
export const AMAZON_KDP_ROYALTIES_EXPLAINED_ROUTE = '/amazon-kdp-royalties-explained';
export const KDP_ROYALTY_RATES_ROUTE = '/kdp-royalty-rates';
export const AMAZON_KDP_ROYALTY_CALCULATOR_ROUTE = '/amazon-kdp-royalty-calculator';
export const HOW_AMAZON_BSR_TRANSLATES_TO_SALES_ROUTE = '/how-amazon-bsr-translates-to-sales';
export const HOW_MUCH_DO_BOOKS_SELL_ON_AMAZON_ROUTE = '/how-much-do-books-sell-on-amazon';
export const HOW_MANY_BOOKS_DO_YOU_NEED_TO_SELL_TO_MAKE_MONEY_ROUTE = '/how-many-books-do-you-need-to-sell-to-make-money';
export const CAN_YOU_MAKE_A_LIVING_WITH_KDP_ROUTE = '/can-you-make-a-living-with-kdp';
export const KDP_INCOME_CALCULATOR_ROUTE = '/kdp-income-calculator';
export const SELF_PUBLISHING_ROI_CALCULATOR_ROUTE = '/self-publishing-roi-calculator';
export const AVERAGE_KDP_INCOME_ROUTE = '/average-kdp-income';
export const KDP_INCOME_EXAMPLES_ROUTE = '/kdp-income-examples';

// HUB
export const KDP_PROBLEMS_ROUTE = '/kdp-problems';
// TREE
export const WHY_MY_BOOK_NOT_SELLING_ROUTE = '/why-my-book-not-selling-on-amazon';
export const WHY_MY_KDP_BOOK_HAS_NO_SALES_ROUTE = '/why-my-kdp-book-has-no-sales';
export const HOW_TO_INCREASE_AMAZON_BOOK_SALES_ROUTE = '/how-to-increase-amazon-book-sales';
export const WHY_MY_KDP_BOOK_NOT_SHOWING_ROUTE = '/why-my-kdp-book-not-showing-on-amazon';
export const KDP_BOOK_NOT_INDEXED_ROUTE = '/kdp-book-not-indexed';
export const HOW_TO_FIX_KDP_INDEXING_ROUTE = '/how-to-fix-kdp-indexing';
export const WHY_MY_BOOK_DISAPPEARED_ROUTE = '/why-my-book-disappeared-from-amazon';
export const AMAZON_KDP_ACCOUNT_SUSPENDED_ROUTE = '/amazon-kdp-account-suspended';
export const AMAZON_KDP_ACCOUNT_TERMINATED_ROUTE = '/amazon-kdp-account-terminated';
export const HOW_TO_RECOVER_KDP_ACCOUNT_ROUTE = '/how-to-recover-kdp-account';
export const AMAZON_KDP_POLICY_VIOLATIONS_ROUTE = '/amazon-kdp-policy-violations';
export const KDP_KEYWORDS_NOT_WORKING_ROUTE = '/kdp-keywords-not-working';
export const KDP_CATEGORY_NOT_SHOWING_ROUTE = '/kdp-category-not-showing';
export const KDP_BOOK_RANKING_DROPPED_ROUTE = '/kdp-book-ranking-dropped';
export const WHY_AMAZON_REMOVED_MY_REVIEWS_ROUTE = '/why-amazon-removed-my-reviews';

// ===== KDP KEYWORD RESEARCH HUB =====
export const KDP_KEYWORD_RESEARCH_ROUTE = '/kdp-keyword-research';
// TREE
export const AI_BOOK_KEYWORD_GENERATOR_ROUTE = '/ai-book-keyword-generator';
export const KDP_KEYWORD_CLEANER_ROUTE = '/kdp-keyword-cleaner';
export const HOW_TO_FIND_KDP_KEYWORDS_ROUTE = '/how-to-find-kdp-keywords';
export const KDP_KEYWORD_RESEARCH_WITHOUT_TOOLS_ROUTE = '/kdp-keyword-research-without-tools';
export const AMAZON_KDP_KEYWORD_RULES_ROUTE = '/amazon-kdp-keyword-rules';
export const KDP_KEYWORD_MISTAKES_ROUTE = '/kdp-keyword-mistakes';
export const HOW_MANY_KEYWORDS_KDP_ROUTE = '/how-many-keywords-kdp';
export const KDP_KEYWORDS_FOR_PUZZLE_BOOKS_ROUTE = '/kdp-keywords-for-puzzle-books';
export const KDP_KEYWORDS_FOR_SELF_HELP_BOOKS_ROUTE = '/kdp-keywords-for-self-help-books';
export const KDP_KEYWORDS_FOR_ROMANCE_BOOKS_ROUTE = '/kdp-keywords-for-romance-books';
export const KDP_KEYWORDS_FOR_COOKBOOKS_ROUTE = '/kdp-keywords-for-cookbooks';
export const KDP_KEYWORD_EXAMPLES_ROUTE = '/kdp-keyword-examples';

// ===== KDP NICHE RESEARCH HUB =====
export const KDP_NICHE_RESEARCH_ROUTE = '/kdp-niche-research';
// TREE
export const BEST_KDP_NICHES_FOR_BEGINNERS_ROUTE = '/best-kdp-niches-for-beginners';
export const LOW_COMPETITION_KDP_NICHES_ROUTE = '/low-competition-kdp-niches';
export const PROFITABLE_KDP_NICHES_ROUTE = '/profitable-kdp-niches';
export const HOW_TO_FIND_KDP_NICHES_ROUTE = '/how-to-find-kdp-niches';
export const KDP_NICHE_RESEARCH_WITH_BSR_ROUTE = '/kdp-niche-research-with-bsr';
export const AMAZON_BOOK_NICHE_RESEARCH_ROUTE = '/amazon-book-niche-research';
export const LOW_CONTENT_BOOK_NICHES_ROUTE = '/low-content-book-niches';
export const NOTEBOOK_NICHES_ROUTE = '/notebook-niches';
export const JOURNAL_NICHES_ROUTE = '/journal-niches';
export const PLANNER_NICHES_ROUTE = '/planner-niches';
export const MEDIUM_CONTENT_BOOK_NICHES_ROUTE = '/medium-content-book-niches';
export const PUZZLE_BOOKS_KDP_ROUTE = '/puzzle-books-kdp';
export const SUDOKU_BOOKS_KDP_ROUTE = '/sudoku-books-kdp';
export const EASY_SUDOKU_BOOKS_KDP_ROUTE = '/easy-sudoku-books-kdp';
export const HARD_SUDOKU_BOOKS_KDP_ROUTE = '/hard-sudoku-books-kdp';
export const LARGE_PRINT_SUDOKU_BOOKS_KDP_ROUTE = '/large-print-sudoku-books-kdp';
export const KIDS_SUDOKU_BOOKS_KDP_ROUTE = '/kids-sudoku-books-kdp';
// ===== PUZZLE / MEDIUM CONTENT NICHES =====
export const WORD_SEARCH_BOOKS_KDP_ROUTE = '/word-search-books-kdp';
export const KIDS_WORD_SEARCH_BOOKS_KDP_ROUTE = '/kids-word-search-books-kdp';
export const LARGE_PRINT_WORD_SEARCH_BOOKS_KDP_ROUTE = '/large-print-word-search-books-kdp';
export const HARD_WORD_SEARCH_BOOKS_KDP_ROUTE = '/hard-word-search-books-kdp';
export const THEMED_WORD_SEARCH_BOOKS_KDP_ROUTE = '/themed-word-search-books-kdp';
export const CROSSWORD_BOOKS_KDP_ROUTE = '/crossword-books-kdp';
export const EASY_CROSSWORD_BOOKS_KDP_ROUTE = '/easy-crossword-books-kdp';
export const HARD_CROSSWORD_BOOKS_KDP_ROUTE = '/hard-crossword-books-kdp';
export const KIDS_CROSSWORD_BOOKS_KDP_ROUTE = '/kids-crossword-books-kdp';
export const LARGE_PRINT_CROSSWORD_BOOKS_KDP_ROUTE = '/large-print-crossword-books-kdp';
export const MAZE_BOOKS_KDP_ROUTE = '/maze-books-kdp';
export const KIDS_MAZE_BOOKS_KDP_ROUTE = '/kids-maze-books-kdp';
export const HARD_MAZE_BOOKS_KDP_ROUTE = '/hard-maze-books-kdp';
export const ANIMAL_MAZE_BOOKS_KDP_ROUTE = '/animal-maze-books-kdp';
export const EDUCATIONAL_MAZE_BOOKS_KDP_ROUTE = '/educational-maze-books-kdp';
export const CRYPTOGRAM_BOOKS_KDP_ROUTE = '/cryptogram-books-kdp';
export const EASY_CRYPTOGRAM_BOOKS_KDP_ROUTE = '/easy-cryptogram-books-kdp';
export const HARD_CRYPTOGRAM_BOOKS_KDP_ROUTE = '/hard-cryptogram-books-kdp';
export const KIDS_CRYPTOGRAM_BOOKS_KDP_ROUTE = '/kids-cryptogram-books-kdp';
export const LARGE_PRINT_CRYPTOGRAM_BOOKS_KDP_ROUTE = '/large-print-cryptogram-books-kdp';
export const WORD_SCRAMBLE_BOOKS_KDP_ROUTE = '/word-scramble-books-kdp';
export const KIDS_WORD_SCRAMBLE_BOOKS_KDP_ROUTE = '/kids-word-scramble-books-kdp';
export const EASY_WORD_SCRAMBLE_BOOKS_KDP_ROUTE = '/easy-word-scramble-books-kdp';
export const HARD_WORD_SCRAMBLE_BOOKS_KDP_ROUTE = '/hard-word-scramble-books-kdp';
export const THEMED_WORD_SCRAMBLE_BOOKS_KDP_ROUTE = '/themed-word-scramble-books-kdp';
export const MISSING_VOWELS_BOOKS_KDP_ROUTE = '/missing-vowels-books-kdp';
export const KIDS_MISSING_VOWELS_BOOKS_KDP_ROUTE = '/kids-missing-vowels-books-kdp';
export const EASY_MISSING_VOWELS_BOOKS_KDP_ROUTE = '/easy-missing-vowels-books-kdp';
export const HARD_MISSING_VOWELS_BOOKS_KDP_ROUTE = '/hard-missing-vowels-books-kdp';
export const VOCABULARY_MISSING_VOWELS_BOOKS_KDP_ROUTE = '/vocabulary-missing-vowels-books-kdp';
export const DOUBLE_WORD_PUZZLE_BOOKS_KDP_ROUTE = '/double-word-puzzle-books-kdp';
export const KIDS_DOUBLE_WORD_PUZZLE_BOOKS_KDP_ROUTE = '/kids-double-word-puzzle-books-kdp';
export const EASY_DOUBLE_WORD_PUZZLE_BOOKS_KDP_ROUTE = '/easy-double-word-puzzle-books-kdp';
export const HARD_DOUBLE_WORD_PUZZLE_BOOKS_KDP_ROUTE = '/hard-double-word-puzzle-books-kdp';
export const THEMED_DOUBLE_WORD_PUZZLE_BOOKS_KDP_ROUTE = '/themed-double-word-puzzle-books-kdp';
export const MATCHING_WORDS_BOOKS_KDP_ROUTE = '/matching-words-books-kdp';
export const KIDS_MATCHING_WORDS_BOOKS_KDP_ROUTE = '/kids-matching-words-books-kdp';
export const EASY_MATCHING_WORDS_BOOKS_KDP_ROUTE = '/easy-matching-words-books-kdp';
export const EDUCATIONAL_MATCHING_WORDS_BOOKS_KDP_ROUTE = '/educational-matching-words-books-kdp';
export const VOCABULARY_MATCHING_WORDS_BOOKS_KDP_ROUTE = '/vocabulary-matching-words-books-kdp';
export const KAKURO_BOOKS_KDP_ROUTE = '/kakuro-books-kdp';
export const EASY_KAKURO_BOOKS_KDP_ROUTE = '/easy-kakuro-books-kdp';
export const HARD_KAKURO_BOOKS_KDP_ROUTE = '/hard-kakuro-books-kdp';
export const LARGE_PRINT_KAKURO_BOOKS_KDP_ROUTE = '/large-print-kakuro-books-kdp';
export const KAKURO_FOR_BEGINNERS_BOOKS_KDP_ROUTE = '/kakuro-for-beginners-books-kdp';
export const ACTIVITY_BOOK_NICHES_ROUTE = '/activity-book-niches';
export const COLORING_BOOK_NICHES_ROUTE = '/coloring-book-niches';
// ===== FICTION =====
export const FICTION_BOOK_NICHES_ROUTE = '/fiction-book-niches';
export const ROMANCE_BOOK_NICHES_ROUTE = '/romance-book-niches';
export const FANTASY_BOOK_NICHES_ROUTE = '/fantasy-book-niches';
// ===== NONFICTION =====
export const NONFICTION_BOOK_NICHES_ROUTE = '/nonfiction-book-niches';
export const SELF_HELP_BOOK_NICHES_ROUTE = '/self-help-book-niches';
export const MINDSET_BOOK_NICHES_ROUTE = '/mindset-book-niches';
export const PRODUCTIVITY_BOOK_NICHES_ROUTE = '/productivity-book-niches';
export const HABIT_BUILDING_BOOK_NICHES_ROUTE = '/habit-building-book-niches';
export const MOTIVATION_BOOK_NICHES_ROUTE = '/motivation-book-niches';
export const ANXIETY_SELF_HELP_BOOK_NICHES_ROUTE = '/anxiety-self-help-book-niches';
export const STRESS_MANAGEMENT_BOOK_NICHES_ROUTE = '/stress-management-book-niches';
export const CONFIDENCE_BOOK_NICHES_ROUTE = '/confidence-book-niches';
export const OVERTHINKING_BOOK_NICHES_ROUTE = '/overthinking-book-niches';
export const SELF_DISCIPLINE_BOOK_NICHES_ROUTE = '/self-discipline-book-niches';
export const TIME_MANAGEMENT_BOOK_NICHES_ROUTE = '/time-management-book-niches';
export const GOAL_SETTING_BOOK_NICHES_ROUTE = '/goal-setting-book-niches';
export const FINANCIAL_SELF_HELP_BOOK_NICHES_ROUTE = '/financial-self-help-book-niches';
export const MINIMALISM_BOOK_NICHES_ROUTE = '/minimalism-book-niches';
export const PERSONAL_GROWTH_BOOK_NICHES_ROUTE = '/personal-growth-book-niches';
export const RELATIONSHIP_SELF_HELP_BOOK_NICHES_ROUTE = '/relationship-self-help-book-niches';
export const SOCIAL_SKILLS_BOOK_NICHES_ROUTE = '/social-skills-book-niches';
export const COOKBOOK_NICHES_ROUTE = '/cookbook-niches';
export const KETO_COOKBOOK_NICHES_ROUTE = '/keto-cookbook-niches';
export const MEDITERRANEAN_COOKBOOK_NICHES_ROUTE = '/mediterranean-cookbook-niches';
export const AIR_FRYER_COOKBOOK_NICHES_ROUTE = '/air-fryer-cookbook-niches';
export const INSTANT_POT_COOKBOOK_NICHES_ROUTE = '/instant-pot-cookbook-niches';
export const SLOW_COOKER_COOKBOOK_NICHES_ROUTE = '/slow-cooker-cookbook-niches';
export const VEGAN_COOKBOOK_NICHES_ROUTE = '/vegan-cookbook-niches';
export const VEGETARIAN_COOKBOOK_NICHES_ROUTE = '/vegetarian-cookbook-niches';
export const GLUTEN_FREE_COOKBOOK_NICHES_ROUTE = '/gluten-free-cookbook-niches';
export const DIABETIC_COOKBOOK_NICHES_ROUTE = '/diabetic-cookbook-niches';
export const KIDS_COOKBOOK_NICHES_ROUTE = '/kids-cookbook-niches';
export const BAKING_COOKBOOK_NICHES_ROUTE = '/baking-cookbook-niches';
export const DESSERT_COOKBOOK_NICHES_ROUTE = '/dessert-cookbook-niches';
export const BREAD_MAKING_COOKBOOK_NICHES_ROUTE = '/bread-making-cookbook-niches';
export const BUDGET_COOKBOOK_NICHES_ROUTE = '/budget-cookbook-niches';
export const MEAL_PREP_COOKBOOK_NICHES_ROUTE = '/meal-prep-cookbook-niches';
export const QUICK_MEALS_COOKBOOK_NICHES_ROUTE = '/quick-meals-cookbook-niches';
export const FAMILY_COOKBOOK_NICHES_ROUTE = '/family-cookbook-niches';
export const REGIONAL_COOKBOOK_NICHES_ROUTE = '/regional-cookbook-niches';
export const ITALIAN_COOKBOOK_NICHES_ROUTE = '/italian-cookbook-niches';
export const MEXICAN_COOKBOOK_NICHES_ROUTE = '/mexican-cookbook-niches';
export const ASIAN_COOKBOOK_NICHES_ROUTE = '/asian-cookbook-niches';
// ===== NICHE GUIDES =====
export const KDP_NICHE_MISTAKES_ROUTE = '/kdp-niche-mistakes';
export const HOW_TO_VALIDATE_BOOK_NICHE_ROUTE = '/how-to-validate-book-niche';
export const HOW_TO_ANALYZE_BOOK_COMPETITION_ROUTE = '/how-to-analyze-book-competition';

// ===== MARKETING HUB =====
export const BOOK_MARKETING_ROUTE = '/book-marketing';
// TREE
export const HOW_TO_MARKET_A_BOOK_ROUTE = '/how-to-market-a-book';
export const HOW_TO_PROMOTE_A_BOOK_ON_AMAZON_ROUTE = '/how-to-promote-a-book-on-amazon';
export const BOOK_LAUNCH_STRATEGY_AMAZON_ROUTE = '/book-launch-strategy-amazon';
export const BOOK_LAUNCH_CHECKLIST_ROUTE = '/book-launch-checklist';
export const HOW_TO_GET_FIRST_BOOK_SALES_ROUTE = '/how-to-get-first-book-sales';
export const FREE_BOOK_MARKETING_STRATEGIES_ROUTE = '/free-book-marketing-strategies';
export const FREE_BOOK_PROMOTION_SITES_ROUTE = '/free-book-promotion-sites';
export const BOOK_PROMOTION_EMAIL_LISTS_ROUTE = '/book-promotion-email-lists';
export const BEST_BOOK_PROMOTION_SITES_ROUTE = '/best-book-promotion-sites';
export const KINDLE_BOOK_PROMOTION_SITES_ROUTE = '/kindle-book-promotion-sites';
export const ARC_READERS_FOR_BOOKS_ROUTE = '/arc-readers-for-books';
export const HOW_TO_BUILD_ARC_TEAM_ROUTE = '/how-to-build-arc-team';
export const HOW_TO_GET_BOOK_REVIEWS_BEFORE_LAUNCH_ROUTE = '/how-to-get-book-reviews-before-launch';
export const HOW_TO_BUILD_AUTHOR_PLATFORM_ROUTE = '/how-to-build-author-platform';
export const EMAIL_LIST_FOR_AUTHORS_ROUTE = '/email-list-for-authors';
export const HOW_TO_PROMOTE_BOOK_ON_SOCIAL_MEDIA_ROUTE = '/how-to-promote-book-on-social-media';
export const HOW_TO_PROMOTE_BOOK_ON_FACEBOOK_ROUTE = '/how-to-promote-book-on-facebook';
export const HOW_TO_PROMOTE_BOOK_ON_TIKTOK_ROUTE = '/how-to-promote-book-on-tiktok';
export const BOOK_MARKETING_CHECKLIST_ROUTE = '/book-marketing-checklist';
export const BOOK_MARKETING_STRATEGY_FOR_SELF_PUBLISHED_AUTHORS_ROUTE = '/book-marketing-strategy-for-self-published-authors';

// ===== AMAZON ADS HUB =====
export const AMAZON_ADS_FOR_BOOKS_ROUTE = '/amazon-ads-for-books';
// TREE
export const HOW_AMAZON_ADS_FOR_BOOKS_WORK_ROUTE = '/how-amazon-ads-for-books-work';
export const AMAZON_ADS_FOR_KDP_BEGINNERS_ROUTE = '/amazon-ads-for-kdp-beginners';
export const AMAZON_ADS_TYPES_EXPLAINED_ROUTE = '/amazon-ads-types-explained';
export const AMAZON_ADS_LAUNCH_STRATEGY_ROUTE = '/amazon-ads-launch-strategy';
export const AMAZON_ADS_KEYWORD_STRATEGY_ROUTE = '/amazon-ads-keyword-strategy';
export const AMAZON_ADS_FOR_BOOK_LAUNCH_ROUTE = '/amazon-ads-for-book-launch';
export const AMAZON_ADS_OPTIMIZATION_STRATEGY_ROUTE = '/amazon-ads-optimization-strategy';
export const HOW_TO_LOWER_ACOS_AMAZON_ADS_ROUTE = '/how-to-lower-acos-amazon-ads';
export const HOW_TO_IMPROVE_AMAZON_ADS_CONVERSION_ROUTE = '/how-to-improve-amazon-ads-conversion';
export const HOW_TO_SCALE_AMAZON_ADS_FOR_BOOKS_ROUTE = '/how-to-scale-amazon-ads-for-books';
export const AMAZON_ADS_BUDGET_STRATEGY_ROUTE = '/amazon-ads-budget-strategy';
export const AMAZON_ADS_BIDDING_STRATEGY_ROUTE = '/amazon-ads-bidding-strategy';
export const AMAZON_ADS_ACOS_EXPLAINED_ROUTE = '/amazon-ads-acos-explained';
export const AMAZON_ADS_CTR_EXPLAINED_ROUTE = '/amazon-ads-ctr-explained';
export const AMAZON_ADS_ROAS_EXPLAINED_ROUTE = '/amazon-ads-roas-explained';
export const WHY_AMAZON_ADS_NOT_WORKING_ROUTE = '/why-amazon-ads-not-working';
export const AMAZON_ADS_NO_IMPRESSIONS_ROUTE = '/amazon-ads-no-impressions';
export const AMAZON_ADS_NO_CLICKS_ROUTE = '/amazon-ads-no-clicks';
export const AMAZON_ADS_HIGH_ACOS_PROBLEM_ROUTE = '/amazon-ads-high-acos-problem';

// ===== DISCOVERABILITY HUB =====
export const KDP_DISCOVERABILITY_ROUTE = '/kdp-discoverability';
// ===== TREE=====
export const HOW_AMAZON_BOOK_RANKING_WORKS_ROUTE = '/how-amazon-book-ranking-works';
export const HOW_TO_RANK_BOOKS_ON_AMAZON_ROUTE = '/how-to-rank-books-on-amazon';
export const HOW_TO_GET_BOOK_DISCOVERED_ROUTE = '/how-to-get-your-book-discovered-on-amazon';
export const HOW_AMAZON_KDP_ALGORITHM_WORKS_ROUTE = '/how-amazon-kdp-algorithm-works';
export const AMAZON_BOOK_RANKING_FACTORS_ROUTE = '/amazon-book-ranking-factors';
export const AMAZON_BSR_VS_DISCOVERABILITY_ROUTE = '/amazon-bsr-vs-discoverability';
export const HOW_AMAZON_KEYWORDS_RANKING_WORKS_ROUTE = '/how-amazon-keywords-ranking-works';
export const HOW_TO_RANK_FOR_AMAZON_KEYWORDS_ROUTE = '/how-to-rank-for-amazon-keywords';
export const AMAZON_KDP_KEYWORD_STRATEGY_ROUTE = '/amazon-kdp-keyword-strategy';
export const HOW_AMAZON_BOOK_CATEGORIES_WORK_ROUTE = '/how-amazon-book-categories-work';
export const HOW_TO_RANK_IN_AMAZON_CATEGORIES_ROUTE = '/how-to-rank-in-amazon-categories';
export const KDP_CATEGORY_STRATEGY_ROUTE = '/kdp-category-strategy';
export const HOW_REVIEWS_AFFECT_RANKING_ROUTE = '/how-reviews-affect-amazon-book-ranking';
export const HOW_CLICKS_AFFECT_AMAZON_RANKING_ROUTE = '/how-clicks-affect-amazon-ranking';
export const HOW_SALES_AFFECT_AMAZON_RANKING_ROUTE = '/how-sales-affect-amazon-ranking';

// ===== KDP RISKS HUB =====
export const KDP_RISKS_AND_BANS_ROUTE = '/kdp-risks-and-bans';
export const BAN_FOR_COPYRIGHT_VIOLATION_ROUTE = '/ban-for-copyright-violation';
export const BAN_FOR_FAKE_REVIEWS_ROUTE = '/ban-for-fake-reviews';
export const HOW_TO_GET_AMAZON_REVIEWS_SAFELY_ROUTE = '/how-to-get-amazon-reviews-safely';

export const FBA_PRODUCTS_ROUTE = '/amazon-fba-product-reviews';
export const PHOTO_AND_VIDEO_ROUTE = '/amazon-photo-video-reviews';
export const HELPFUL_ROUTE = '/amazon-helpful-votes-report';
export const EASY_OR_HARD_ROUTE = '/blog/get-amazon-book-reviews-easy-or-hard';
export const PHYSICAL_PRODUCT_ROUTE = '/blog/get-amazon-reviews-for-fba-products';
export const VERIFIED_LAUNCH_ROUTE = '/blog/get-verified-purchase-amazon-book-reviews';

export const PUBLIC_BOOK_LIBRARY_ROUTE = '/arc-reviews-book-library';
export const PUBLIC_PRODUCT_STORE_ROUTE = '/free-reviews-product-store';
export const FULL_LIBRARY_ROUTE = '/full-arc-book-library';

export const GETTING_AMAZON_BOOK_REVIEWS_FOR_COOKBOOKS_ROUTE = '/getting-amazon-book-reviews-for-cookbooks';
export const GETTING_AMAZON_BOOK_REVIEWS_FOR_FOOD_AND_WINE_ROUTE = '/getting-amazon-book-reviews-for-food-and-wine';
export const GETTING_AMAZON_BOOK_REVIEWS_FOR_BUSINESS_AND_MONEY_ROUTE =
    '/getting-amazon-book-reviews-for-business-and-money';
export const GETTING_AMAZON_BOOK_REVIEWS_FOR_ART_AND_PHOTOGRAPHY_ROUTE =
    '/getting-amazon-book-reviews-for-art-and-photography';
export const FREE_AMAZON_BOOK_REVIEWS_FOR_HISTORY_AND_BIOGRAPHIES_ROUTE = '/free-amazon-book-reviews-for-history-and-biographies';
export const FREE_AMAZON_BOOK_REVIEWS_FOR_YOUNG_ADULT_BOOKS_ROUTE =
    '/free-amazon-book-reviews-for-young-adult-books';
export const FREE_AMAZON_BOOK_REVIEWS_FOR_CHILDREN_AND_KIDS_BOOKS_ROUTE =
    '/free-amazon-book-reviews-for-children-and-kids-books';
export const FREE_AMAZON_BOOK_REVIEWS_FOR_COMICS_AND_GRAPHIC_NOVELS_ROUTE =
    '/free-amazon-book-reviews-for-comics-and-graphic-novels';
export const GET_AMAZON_BOOK_REVIEWS_FOR_COMPUTERS_AND_TECHNOLOGY_ROUTE =
    '/get-amazon-book-reviews-for-computers-and-technology';
export const GET_AMAZON_BOOK_REVIEWS_FOR_CRAFTS_HOBBIES_AND_HOME_ROUTE =
    '/get-amazon-book-reviews-for-crafts-hobbies-and-home';
export const GET_AMAZON_BOOK_REVIEWS_FOR_EDUCATION_AND_TEACHING_ROUTE =
    '/get-amazon-book-reviews-for-education-and-teaching';
export const AMAZON_REVIEWS_FOR_ENGINEERING_AND_TRANSPORTATION_BOOKS_ROUTE =
    '/amazon-reviews-for-engineering-and-transportation-books';
export const AMAZON_REVIEWS_FOR_HEALTH_AND_FITNESS_BOOKS_ROUTE =
    '/amazon-reviews-for-health-and-fitness-books';
